module.exports = __webpack_public_path__ + "static/media/Ex1-S7.8880df66.PNG";